(function () {
  // if (!window.location.href.includes("product")) return;
  if (window.__PDP_VARIANT_SIZE_INIT__) return;
  window.__PDP_VARIANT_SIZE_INIT__ = true;

  (function injectCSS() {
    const css = `
fieldset.option-selector label {
  border-radius: 20px !important;
  min-width: 60px !important;
}

.variant-size-chart {
  margin: 5px 0 !important;
}
`;
    const style = document.createElement("style");
    style.textContent = css;
    document.head.appendChild(style);
  })();

  const sizeMap = {
    "36": "XS",
    "38": "S",
    "40": "M",
    "42": "L",
    "44": "XL",
    "46": "XXL",
    "48": "3XL",
    "50": "4XL",
    "52": "5XL",
    "54": "6XL",
    "56": "7XL",
  };

  function enhanceSpan(span) {
    if (!span || span.dataset.sizeEnhanced === "1") return;
    const original = (span.textContent || "").trim();
    const mapped = sizeMap[original];
    if (mapped) {
      span.textContent = `${mapped} - ${original}`;
      span.dataset.sizeEnhanced = "1";
    }
  }

  function apply(root) {
    root.querySelectorAll('fieldset.option-selector label span').forEach(enhanceSpan);
  }

  apply(document);

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('fieldset.option-selector label span')) {
          enhanceSpan(node);
        } else {
          apply(node);
        }
      }
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
